export async function subjectRequest(data, address) {
	try {
		const response = await fetch(`${address}`, {
			method: 'POST',
			body: data,
		})
			.then((data) => {
				return data.json();
			})
			.then((data) => {
				if (data.success && data.success === 'Y') {
					return {
						status: 'success',
					};
				}
				if (data.error) {
					return {
						status: 'error',
						message: `<h4>Ошибка</h4><p>${data.error}</p>`,
					};
				}
			});
		return response;
	} catch (error) {
		return {
			status: 'error',
			message: `<h4>Ошибка</h4><p>${error}</p>`,
		};
	}
}
